module.exports = __webpack_public_path__ + "img/gift3-05-c1.0309c515.png";